
import { getElement, getElements, ifSelectorExist } from "./utils";

const AWARDS_ANIMATION_SPEED = 60; // speed in px per second

export const loopAnimations = () => {
  const awardsAnimations = getElements(".awards-animation__box");
  if (ifSelectorExist(awardsAnimations)) {
    awardsAnimations.forEach((elem) => {
      const awardsInner = elem.querySelector(".awards-animation__list");

      if (!awardsInner || !awardsInner.children.length) {
        return;
      }

      const awardsContent = Array.from(awardsInner.children);

      const duration = awardsInner.scrollWidth / AWARDS_ANIMATION_SPEED;
      awardsInner.style.setProperty("--animation-duration", `${duration}s`);

      awardsContent.forEach((item) => {
        const awardsDuplicatedItem = item.cloneNode(true);
        awardsInner.appendChild(awardsDuplicatedItem);
      });
    });
  }
};
